/** RFC 9457 problem details as returned by the backend. */
export interface FieldErrorDto {
  field: string;
  code: string;
  message: string;
}

export interface ProblemDetail {
  type?: string;
  title?: string;
  status: number;
  detail?: string;
  code?: string;
  requestId?: string;
  errors?: FieldErrorDto[];
}

export class ApiError extends Error {
  readonly status: number;
  readonly problem: ProblemDetail;

  constructor(problem: ProblemDetail) {
    super(problem.detail ?? problem.title ?? `HTTP ${problem.status}`);
    this.name = 'ApiError';
    this.status = problem.status;
    this.problem = problem;
  }

  get code(): string | undefined {
    return this.problem.code;
  }

  get fieldErrors(): FieldErrorDto[] {
    return this.problem.errors ?? [];
  }

  get isVersionConflict(): boolean {
    return this.status === 409 && this.problem.code === 'VERSION_CONFLICT';
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}
